(function () {
    const requestAnimationFrame = window.requestAnimationFrame || (<any>window).mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame || (<any>window).msRequestAnimationFrame;
    window.requestAnimationFrame = requestAnimationFrame;
})();


export interface ForceEndFunc {
    (): boolean;
}

export interface PausedFunc {
    (): boolean;
}

export interface TimingFunc {
    (timeFraction: number): number;
}

export interface DrawFunc {
    (progress: number): void;
}

export interface IAnimateOptions {
    duration: number;
    forceEnd: ForceEndFunc;
    paused: PausedFunc;
    timing: TimingFunc;
    draw: DrawFunc;
}

export function animate(options: IAnimateOptions) {

    let start: number;
    if ("performance" in window == false || "now" in window.performance == false) {
        let nowOffset = Date.now();
        if (performance.timing && performance.timing.navigationStart){
            nowOffset = performance.timing.navigationStart
        }
        start = Date.now() - nowOffset
    } else {
        start = performance.now();
    }

    requestAnimationFrame(function animate(time) {
        // timeFraction от 0 до 1
        let timeFraction: number;
        timeFraction = (time - start) / options.duration;
        if (timeFraction > 1) timeFraction = 1;

        if (options.forceEnd()) {
            timeFraction = 1
        }

        if (!options.paused()) {
            // текущее состояние анимации
            let progress = options.timing(timeFraction);

            options.draw(progress);

            if (timeFraction < 1) {
                requestAnimationFrame(animate);
            }

        }

    });
}
